import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue";
import { get_token, get_user_details } from "@/router";

export default {
  components: {
    HomeNavBar
  },
  mounted() {
    this.token_exists = get_token();
    this.user_details = get_user_details();
    this.filter_membership_payment_history();
  },
  data() {
    return ({
      user: this.getUserData(),
      token_exists: false,
      user_details: {
        user_id: ''
      },
      payment_history_loading: true,
      membership_payment_history: [],
      membership_payment_history_id: null,
      current_membership: null,
      membership_name: '',
      membership_type: '',
      membership_price: 0,
      billing_cycle: '',
      renewal_date: null,
      is_active: false,
      userHasPaid: false
    });
  },
  computed: {
    has_current_membership() {
      return Boolean(this.current_membership || this.membership_name);
    }
  },
  methods: {
    getUserData() {
      return ({
        user_id: ''
      });
    },
    getToken() {
      return get_token();
    },
    go_back() {
      this.$router.back();
    },
    format_currency(amount) {
      const value = Number(amount || 0);
      return `R${value.toFixed(2)}`;
    },
    format_display_date(date_value) {
      if (!date_value) {
        return '--';
      }

      const parsed_date = new Date(date_value);
      if (Number.isNaN(parsed_date.getTime())) {
        return '--';
      }

      return parsed_date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      });
    },
    get_payment_status(payment) {
      return String(payment?.payment_status?.status || '').toLowerCase();
    },
    resolve_current_membership(history = []) {
      const current_entry = history.find((payment) => this.get_payment_status(payment) === 'paid');
      return current_entry?.membership || null;
    },
    get_first_payment_history_entry(history = []) {
      return history[0] || null;
    },
    set_membership_history_state(history = []) {
      this.membership_payment_history = history;
      this.current_membership = this.resolve_current_membership(history);
      this.userHasPaid = history.some(
        (payment) => this.get_payment_status(payment) === "paid"
      );
    },
    set_payment_history_entry_state(first_entry) {
      this.is_active = first_entry?.is_active || false;
      this.membership_payment_history_id = first_entry?.id || null;
      this.renewal_date = first_entry?.valid_until || null;
    },
    get_membership_detail_state(first_membership) {
      return ({
        membership_name: this.get_membership_name(first_membership),
        membership_type: this.get_membership_type(first_membership),
        billing_cycle: this.get_billing_cycle(first_membership),
        membership_price: this.get_membership_price(first_membership)
      });
    },

    get_membership_name(membership) {
      return membership?.name || '';
    },

    get_membership_type(membership) {
      return membership?.membership_type?.name || '';
    },

    get_billing_cycle(membership) {
      return membership?.billing_cycle?.name || '';
    },

    get_membership_price(membership) {
      return membership?.membership_pricing?.[0]?.price || 0;
},
    set_membership_detail_state(first_membership) {
      const membership_detail_state = this.get_membership_detail_state(first_membership);

      this.membership_name = membership_detail_state.membership_name;
      this.membership_type = membership_detail_state.membership_type;
      this.billing_cycle = membership_detail_state.billing_cycle;
      this.membership_price = membership_detail_state.membership_price;
    },
    apply_membership_payment_history(history = []) {
      const first_entry = this.get_first_payment_history_entry(history);
      const first_membership = first_entry?.membership || null;

      this.set_membership_history_state(history);
      this.set_payment_history_entry_state(first_entry);
      this.set_membership_detail_state(first_membership);
    },
    handle_membership_payment_history_success(response) {
      const history = response?.data?.payment_history || [];
      this.apply_membership_payment_history(history);
    },
    filter_membership_payment_history() {
      this.token_exists = get_token();

      if (!this.user.user_id) {
        this.user.user_id = this.$route.params.user_id || this.user_details.user_id;
      }

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/filter_user_membership_payment_history/`,
        method: "POST",
        data: JSON.stringify({ user_id: this.user.user_id }),
        headers: this.token_exists
          ? {
              Authorization: `Token ${this.getToken()}`,
              "Content-Type": "application/json",
            }
          : { "Content-Type": "application/json" },
        success: (response) => {
          this.handle_membership_payment_history_success(response);
        },
        complete: () => {
          this.payment_history_loading = false;
        },
      });
    },
    navigate_to_plans() {
    this.$router.push('/view_membership/');
    },
  }
};
